<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `álbumes`,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <router-link to="/addAdvertising" class="btn main-bg">
          <i class="fa fa-plus mr-1"></i>Agregar album
        </router-link>

        <div class="row mt-5">
          <div
            class="col-md-4"
            v-for="(media, index) in mediaList"
            :key="index"
          >
            <div class="card mb-3" style="width: 100%; height: 420px">
              <img
                class="card-img-top"
                :src="media.FileLocation"
            
                style="width: 100%; height: 300px"
              />
              <label class="ml-3 mt-3 title">{{ media.Title }}</label> 
        
              <button
                v-show="file == null"
                class="btn btn-outline-primary"
                type="button"
                @click="goToDetail(media.Id)"
          
              >
                detalle       <i class="fa fa-edit"></i>
              </button>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { CompanyService } from "../../services/CompanyService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  name: "CompaniesList",
  components: {
    Loader,
    Breadcrumbs,
  },
  data: function () {
    return {
      mediaList: [],
      servicesTypes: [],
      loading: false,
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 7,
      },
      companyService: new CompanyService(),
    };
  },
  methods: {
    goToDetail(id){
      this.$router.push(`detailAlbum/${id}`);
    
    },
    async getMedias() {
      try {
        this.loading = true;
        const res = await this.companyService.getGalries();
        this.mediaList = res.data;
        console.log(this.mediaList);
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
        this.loading = false;
      }
    },
    dialgoMedia(media) {
      Swal.fire({
        title: "Esta seguro de eliminar esta publicidad",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Cancelar",
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.dismiss != "cancel") {
          this.removeMedia(media);
        }
      });
    },
    async removeMedia(media) {
      try {
        this.loading = true;
        await this.companyService.removeMedia(media);
        this.getServices();
        console.log(this.mediaList);
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
        this.loading = false;
      }
    },
  },
  mounted: async function () {
    +(await this.getMedias());
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
              <style lang="scss" scoped>
                @import "../../assets/scss/colors";
                .w100 {
                  width: 100%;
                }
                h3 {
                  margin: 40px 0 0;
                }
                .form-panel {
                  border: solid 0.1em #ccc;
                  border-radius: 4px;
                  margin: 4px 0 5px 0;
                }
                td,
                th {
                  font-weight: 400;
                }
                .fa {
                  font-size: 1.2rem;
                }
              </style>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
